/** Standard list-page pagination defaults used across the backoffice. */
export const DEFAULT_PAGE_SIZE = 10;

export const PAGE_SIZE_OPTIONS: readonly number[] = [10, 20, 30, 50, 100];
